import { create } from 'zustand';
import { toast } from 'sonner';
import { api } from './auth';

export const FAV_ROLES = ['SUPER_ADMIN', 'FULL_ADMIN', 'FIRM_ADMIN'];

// Menüden düz sayfa kataloğu: path → { path, label, icon }
export const flattenMenu = (items) => {
  const out = {};
  const add = (it) => { if (it.path && it.path !== '/dashboard' && !out[it.path]) out[it.path] = { path: it.path, label: it.label, icon: it.icon }; };
  items.forEach((it) => { add(it); (it.children || []).forEach(add); });
  return out;
};

export const matchPage = (catalog, pathname) => Object.values(catalog)
  .filter((p) => pathname === p.path || pathname.startsWith(p.path + '/'))
  .sort((a, b) => b.path.length - a.path.length)[0] || null;

export const useFavorites = create((set, get) => ({
  items: [],
  loaded: false,
  catalog: {},
  load: async () => {
    if (get().loaded) return;
    set({ loaded: true });
    try { set({ items: (await api.get('/me/favorites')).data.data || [] }); } catch { set({ loaded: false }); }
  },
  setCatalog: (catalog) => set({ catalog }),
  save: async (items) => {
    const prev = get().items;
    set({ items });
    try { await api.put('/me/favorites', { items: items.map(({ path, label }) => ({ path, label })) }); }
    catch { set({ items: prev }); toast.error('Favoriler kaydedilemedi'); }
  },
  toggle: (page) => {
    const { items, save } = get();
    const has = items.some((i) => i.path === page.path);
    save(has ? items.filter((i) => i.path !== page.path) : [...items, { path: page.path, label: page.label }]);
    toast.success(has ? 'Favorilerden çıkarıldı' : 'Favorilere eklendi');
  },
}));
